export default __webpack_public_path__ + "static/media/192.c7a4fc4c.gif";